export { AnimatedTabBar as default } from './AnimatedTabBar';
export { AnimatedTabBarView } from './AnimatedTabBarView';

export { TabsConfig } from './types';

export {
  FlashyTabBarConfig,
  FlashyTabBarItemConfig,
  FlashyTabBarItem,
  FlashyTabBarItemProps,
  FlashyTabBarIconProps,
} from './presets/flashy';
